import React, { useState } from "react";
import "../../style/ViewEventModal.css";
import CloseIcon from "@mui/icons-material/Close";

const ViewEventModal = ({ isOpen, event, onClose, onUpdate, onDelete, tags = [] }) => {
  if (!isOpen || !event) return null;
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [editedEvent, setEditedEvent] = useState({ ...event });

  const handleChange = (e) => {
    setEditedEvent({
      ...editedEvent,
      [e.target.name]:
        e.target.name === "tag_id" ? parseInt(e.target.value) || null : e.target.value,
    });
  };  

  const handleSave = () => {
    onUpdate(editedEvent);
    setIsEditing(false);
  };

  return (
    <div className="modal-overlay">
        <div className="modal-content">
            <div className="modal-header">
                {isEditing ? (
                    <input
                        type="text"
                        name="title"
                        value={editedEvent.title}
                        onChange={handleChange}
                        className="modal-input"
                    />
                ) : (
                    <h2>{event.title}</h2>
                )}
                <CloseIcon className="close-icon" onClick={onClose} />
            </div>

            <div className="modal-body">
            <p>
                <strong>Category:</strong>
                {isEditing ? (
                    <select
                    name="tag_id"
                    value={editedEvent.tag_id || ""}
                    onChange={handleChange}
                    className="modal-input"
                    >
                    <option value="">None</option>
                    {tags.map((tag) => (
                        <option key={tag.id} value={tag.id}>
                        {tag.tag_name}
                        </option>
                    ))}
                    </select>
                ) : (
                    <>
                    {event.tag_name || "No category"}
                    {event.tag_color && (
                        <span
                        style={{
                            display: "inline-block",
                            width: "14px",
                            height: "14px",
                            borderRadius: "3px",
                            backgroundColor: event.tag_color,
                            marginLeft: "5px",
                            verticalAlign: "middle"
                        }}
                        />
                    )}
                    </>
                )}
                </p>


                <p>
                    <strong>Date:</strong> 
                    {isEditing ? (
                        <input
                            type="date"
                            name="event_date"
                            value={editedEvent.event_date}
                            onChange={handleChange}
                            className="modal-input"
                        />
                    ) : (
                        event.event_date
                    )}
                </p>
                <p>
                    <strong>Time:</strong> 
                    {isEditing ? (
                        <input
                            type="time"
                            name="event_time"
                            value={editedEvent.event_time}
                            onChange={handleChange}
                            className="modal-input"
                        />
                    ) : (
                        event.event_time
                    )}
                </p>
                <p>
                    <strong>Location:</strong> 
                    {isEditing ? (
                        <input
                            type="text"
                            name="location"
                            value={editedEvent.location}
                            onChange={handleChange}
                            className="modal-input"
                        />
                    ) : (
                        event.location || "N/A"
                    )}
                </p>
                <p>
                    <strong>Description:</strong> 
                    {isEditing ? (
                        <textarea
                            name="description"
                            value={editedEvent.description}
                            onChange={handleChange}
                            className="modal-textarea"
                        />
                    ) : (
                        event.description || "No description"
                    )}
                </p>
            </div>

            <div className="modal-footer">
                {isEditing ? (
                    <>
                        <button className="modal-button" onClick={handleSave}>Save</button>
                        <button className="delete-button" onClick={() => setIsEditing(false)}>Cancel</button>
                    </>
                ) : (
                    <>
                        <button className="edit-button" onClick={() => setIsEditing(true)}>Edit</button>
                        <button
                            className="delete-button"
                            onClick={() => {
                                const confirmed = window.confirm("Are you sure you want to delete this event?");
                                if (confirmed) {
                                onDelete(event.id);
                                }
                            }}
                        >
                            Delete
                        </button>
                    </>
                )}
            </div>
        </div>
    </div>
);
};

export default ViewEventModal;